var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 31.56C5.64 31.56 3.8 30.84 2.28 29.4C0.76 27.88 0 26.08 0 24C0 23.04 0.12 22.08 0.36 21.12C0.68 20.08 1.24 18.72 2.04 17.04L10.08 0H17.28L12.48 18C14.56 19.6 15.6 21.6 15.6 24C15.6 26.08 14.8 27.88 13.2 29.4C11.68 30.84 9.88 31.56 7.8 31.56ZM29.16 31.56C27 31.56 25.16 30.84 23.64 29.4C22.12 27.88 21.36 26.08 21.36 24C21.36 23.04 21.48 22.08 21.72 21.12C22.04 20.08 22.6 18.72 23.4 17.04L31.44 0H38.64L33.84 18C35.92 19.6 36.96 21.6 36.96 24C36.96 26.08 36.16 27.88 34.56 29.4C33.04 30.84 31.24 31.56 29.16 31.56Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.6a83d15b.svg";
export { ForwardRef as ReactComponent };